import { TripSaveEntityInputs } from '@shared-ui/trips-save-item';
import { toJS } from 'mobx';
import { SearchCriteriaStore, SearchFormStore } from 'src/stores';
import {
  flightSearchTravelersDetailsMapper,
  flightSearchSecondaryShoppingCriteriaMapper,
  flightSearchPreferencesMapper
} from '../trips-save-entity-inputs-mapper';

export const useTripsSaveEntityInputs = (
  searchCriteriaStore: SearchCriteriaStore,
  searchFormStore: SearchFormStore
): TripSaveEntityInputs => ({
  saveItemInput: {
    productSearchCriteria: {
      flightSearchCriteria: {
        primary: {
          journeyCriterias: searchFormStore.getJourneyCriteriaInputFromSearchForm(
            searchCriteriaStore.searchCriteria.flightsSearchContext.tripType
          ),
          searchPreferences: flightSearchPreferencesMapper(toJS(searchCriteriaStore.searchCriteria.searchPreferences)),
          travelers: flightSearchTravelersDetailsMapper(toJS(searchCriteriaStore.searchCriteria.travelerDetails)),
          tripType: searchCriteriaStore.searchCriteria.flightsSearchContext.tripType
        },
        secondary: searchCriteriaStore.searchCriteria.searchFilterValuesList
          ? flightSearchSecondaryShoppingCriteriaMapper(toJS(searchCriteriaStore.searchCriteria.searchFilterValuesList))
          : null
      }
    }
  }
});
